import AddLabels from './AddLabels';
import LabelGroup from './LabelGroup';

export default function PageHeaderLabels({
  canEdit = true,
  addLabelTestId,
  hydrateLabels = true,
}: {
  canEdit?: boolean;
  addLabelTestId?: string;
  hydrateLabels?: boolean;
}) {
  return (
    <div className="flex items-center">
      <LabelGroup canEdit={canEdit} hydrateLabels={hydrateLabels} />
      {canEdit && <AddLabels addLabelTestId={addLabelTestId} />}
    </div>
  );
}
